import { render } from "./FileViewer.vue?vue&type=template&id=7fae112f&scoped=true"
import script from "./FileViewer.vue?vue&type=script&lang=js"
export * from "./FileViewer.vue?vue&type=script&lang=js"

import "./FileViewer.vue?vue&type=style&index=0&id=7fae112f&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fae112f"]])

export default __exports__